import { useEffect } from 'react';

export function useElementViewed(logger, elementScope) {
  useEffect(() => {
    logger.logTrace(`${elementScope}|displayed`);
    return () => logger.logTrace(`${elementScope}|hidden`);
  }, [logger, elementScope]);
}
